import { HttpStatusCode, isHttpError } from '@core/http-client'

export const isLikeStateAlreadySet = (error: unknown) =>
    isHttpError(error) && error.response.status === HttpStatusCode.UNPROCESSABLE_ENTITY
